// app/studente/studenti.js

(function () {
    'use strict';
    var controllerId = 'studenteDoc';
    angular.module('app').controller(controllerId, ['common', '$scope', '$rootScope', '$location', 'bootstrap.dialog', '$routeParams', 'datacontext', 'sectionMenu', '$translate', '$uibModal', '$timeout', studenteDoc]);

    function studenteDoc(common, $scope, $rootScope, $location, bDialog, $routeParams, datacontext, sectionMenu, $translate, $uibModal, $timeout) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
                      
        var vm = this;
        vm.title = 'Allievi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "StudenteDoc"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.newPassword = '';

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        
        //Elenchi dettaglio
        vm.list = {};
        vm.list.ordine = ['Codice Fiscale', 'Email', 'Nominativo'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        
        vm.ordine = vm.list.ordine[2];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Filtro
        vm.filter = {};
        vm.filter.nominativo = ' ';
        
        vm.filter.classeId = 0;        
        
        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        //Pannello Sessioni
        //vm.activated = false;
        vm.loadMoreSessioni = getAllSessioniStudenteByFilter;
        vm.loadAllSessioni = getAllSessioniStudente;
        vm.pageSessioni = 1;
        vm.countRecordsSessioni = 0;
        vm.sessioniStudente = [];
        vm.filter.ricerca = '';        
        vm.fAnnoSessioni = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.annoSessioni = vm.fAnnoSessioni;
        vm.studentiPresenti = 0;
        vm.filter.presenti = vm.studentiPresenti;
        vm.cercaSessioni = cercaSessioni;
        vm.goSession = goSession;
        vm.modificaPassword = modificaPassword;

        //Pannello Schede competenze
        //vm.getSchedaCompetenze = getSchedaCompetenze;// da levare

        vm.loadMoreDidattica = getAllDidatticaStudenteByFilter;
        vm.loadAllDidattica = getAllDidatticaStudente;
        vm.pageDidattica = 1;
        vm.countRecordsDidattica = 0;
        vm.didatticaStudente = [];
        vm.filter.ricercaDidattica = '';        
        vm.cercaDidattica = cercaDidattica;

        vm.listDidattica = {};
        vm.listDidattica.ordine = ['Test', 'Materia', 'Docente', 'Effettuato'];
        vm.listDidattica.ordine = common.setOrdine(vm.listDidattica.ordine);

        vm.ordineDidattica = vm.listDidattica.ordine[3];
        vm.selectOrdineDidattica = function (item) {
            vm.ordineDidattica = item;
            cercaDidattica();
        };
        vm.modalDetailAC = modalDetailAC;

        //Elenchi dettaglio
        vm.listSessioni = {};
        vm.listSessioni.ordine = ['Test', 'Materia', 'Docente', 'Effettuato', 'Voto'];
        vm.listSessioni.ordine = common.setOrdine(vm.listSessioni.ordine);

        vm.ordineSessioni = vm.listSessioni.ordine[3];
        vm.selectOrdineSessioni = function (item) {
            vm.ordineSessioni = item;
            cercaSessioni();
        };


        //Elenchi per filtri e finestra modale di Create e Update
        vm.classi = [];
        vm.province = [];
        vm.comuni = [];

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.getClassiStudente = getClassiStudente;
        vm.annoChanged = function () {
            vm.classi = getListClassi();
            cerca();
        };
        vm.updateAccount = updateAccount;
        vm.invioCredenziali = invioCredenziali;

        //Gestione Attach
        vm.fAttach = {};
        vm.filterAttach = '';
        vm.setfAttach = setfAttach;
        vm.list.attach = [];
        vm.getListAttach = getListAttach;
        vm.tSourceCode_def = 'ALV';
        vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;

        //PDP
        vm.attivaPdp = attivaPdp;
        vm.annullaPdp = annullaPdp;
        vm.getPdp = getPdp;
        vm.update = updatePdp;

        //SESSION
        //vm.getSessioniStudente = getSessioniStudente;
        //vm.getAllSessioniStudenteByFilter = getAllSessioniStudenteByFilter;

        //Opzioni slider
        vm.slider = { 
            minValue: 10,
            maxValue: 100,
            value:100,
            options: {                
                showSelectionBar: true,
                step: 1,
                precision: 1,
                floor: 0,
                ceil: 100,
                hideLimitLabels: true,
                translate: function (value) {
                    return value + '%';
                }
            }
        };

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getListClassi(), getTSource(vm.tSourceCode_def), getTAttach(vm.tSourceCode_def)];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.StudenteId != null) {                            
                            setView('detail');
                            getRecord($routeParams.StudenteId, 0);
                        }

                        //vm.activated = true;
                        //cercaSessioni();
                    });
        }
        
        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {           
            return vm.view = view;
        }
        function cercaSessioni() {
            vm.sessioniStudente = [];
            vm.countRecordsSessioni = 0;
            vm.pageSessioni = 1;
            vm.filter.annoSessioni = vm.fAnnoSessioni == null ? -1 : vm.fAnnoSessioni;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.presenti = vm.studentiPresenti == null ? '' : vm.studentiPresenti;
            if (vm.studentiPresenti == true)
                vm.filter.presenti = 1;
            else
                vm.filter.presenti = 0;
            vm.loading = false;
            //return getSessioniStudente();
            return getAllSessioniStudenteByFilter();
        }

        function countSessioniStudenteByFilter() {
            return datacontext.reportStudenteSession_countAllByStudenteId(vm.record.Id, vm.filter.ricerca, vm.filter.annoSessioni, vm.filter.presenti).then(function (data) {
                if (data) {
                    vm.countRecordsSessioni = data;
                }
            });
        }

        function getAllSessioniStudenteByFilter() {
            //if (!vm.activated) return;
            if (vm.loading === true) return;
            if (vm.countRecordsSessioni == 0) countSessioniStudenteByFilter();
            else if (vm.countRecordsSessioni <= vm.sessioniStudente.length) return;

            vm.loading = true;
            return datacontext.reportStudenteSession_getAllByStudenteId(vm.pageSize, vm.pageSessioni, vm.record.Id, vm.filter.ricerca, vm.filter.annoSessioni, vm.filter.presenti, vm.ordineSessioni.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.pageSessioni++;
                    data.forEach(function (item) {
                        vm.sessioniStudente.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAllSessioniStudente() {
            if (vm.sessioniStudente.length < vm.countRecordsSessioni) {
                getAllSessioniStudenteByFilter().then(function () { getAllSessioniStudente(); });
            }
        }

        //inizio didattica
        function cercaDidattica() {
            vm.didatticaStudente = [];
            vm.countRecordsDidattica = 0;
            vm.pageDidattica = 1;
            vm.filter.ricercaDidattica = vm.fRicercaDidattica == null ? '' : vm.fRicercaDidattica;
            vm.loading = false;
            return getAllDidatticaStudenteByFilter();
        }        

        function countDidatticaStudenteByFilter() {
            return datacontext.reportStudenteSchedaCompetenze_countAllByStudenteId(vm.record.Id, vm.filter.ricercaDidattica).then(function (data) {
                if (data) {
                    vm.countRecordsDidattica = data;
                }
            });
        }

        function getAllDidatticaStudenteByFilter() {
            //if (!vm.activated) return;
            if (vm.loading === true) return;
            if (vm.countRecordsDidattica == 0) countDidatticaStudenteByFilter();
            else if (vm.countRecordsDidattica <= vm.didatticaStudente.length) return;

            vm.loading = true;
            return datacontext.reportStudenteSchedaCompetenze_getAllByStudenteId(vm.pageSize, vm.pageDidattica, vm.record.Id, vm.filter.ricercaDidattica, vm.ordineDidattica.value).then(function (data) {                
                if (data.constructor === Array) {
                    vm.pageDidattica++;
                    data.forEach(function (item) {
                        vm.didatticaStudente.push(item);
                    });
                }
                vm.loading = false;
                //getSchedaCompetenze();
            });
        }

        function getAllDidatticaStudente() {
            if (vm.didatticaStudente.length < vm.countRecordsSessioni) {
                getAllDidatticaStudenteByFilter().then(function () { getAllDidatticaStudente(); });
            }
        }

        function modalDetailAC(item, stud) {
            var modalDetail = {};
            var allievo = {};
            var readonly = true;
            allievo.studente = stud.Cognome +" "+ stud.Nome;
            datacontext.schedaCompetenzeSession_get(item.Id).then(function (data) {
                angular.copy(data, modalDetail);                
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/EDUP_Session/modal/schedaCompetenzeSessionDetail.html?version=43',
                    controller: 'schedaCompetenzeSessionDetail',
                    windowClass: 'modal-wide',
                    resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                        schedaCompetenzeSessionDetail: function () {
                            return modalDetail;
                        },
                        allievo: function () {
                            return allievo;
                        },
                        readonly: function () {
                            return readonly;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {                    
                });
            });

           
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.nominativo = vm.fNominativo == null ? '' : vm.fNominativo;            
            vm.filter.classeId = vm.fClasseId == null ? 0 : vm.fClasseId;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;

            vm.filter.annoSessioni = vm.fAnnoSessioni == null ? -1 : vm.fAnnoSessioni;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;            
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.studente_countAllByUsername(vm.filter.anno, vm.filter.nominativo, vm.filter.classeId).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.studente_getAllByUsername(vm.pageSize, vm.page, vm.filter.anno, vm.filter.nominativo, vm.filter.classeId, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.studente_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                getClassiStudente();                                
                getListAttach(vm.record.Id);
                //cercaSessioni();
                cercaDidattica();
                getPerformanceStudenteMaterie();

                $timeout(function () {
                    setView('detail');
                }, 200);                
            });
        }
        /*
        function getSessioniStudente() {
            console.info("presenti", vm.filter.presenti);
            return datacontext.reportStudenteSession_getAllByStudenteId(vm.pageSize, vm.pageSessioni, vm.record.Id, vm.filter.ricerca, vm.filter.annoSessioni, vm.filter.presenti).then(function (data) {
                console.info("sessioni", data);
                return vm.sessioniStudente = data;
            });
        }
        */
        
        //Elenchi Parametri
        function getListClassi() {            
            var anno = vm.fAnno == null ? -1 : vm.fAnno;
            return datacontext.classe_getAllList(anno).then(function (data) {
                return vm.classi = data;
            });
        }        

        function getClassiStudente() {            
            return datacontext.classe_getAllByStudenteId(vm.record.Id, true).then(function (data) {
                return vm.classiStudente = data;
            });
        }

        //Gestione Attach
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAll(0, 0, vm.tSourceCode_def, 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                vm.list.b_attach = true;                
                return vm.list.attach = data;
            });
        }

        function addAttach(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Cognome + ' ' + vm.record.Nome };            

            var modalInstance = $uibModal.open({
                templateUrl: '/app/attach/modal/attachAdd.html?version=43',
                controller: 'attachAdd',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError($translate.instant('ErroreFormato'));
                if (returnItem == "400") return logError($translate.instant('ErroreRegistrazione')) +'[' + returnItem +']';//('Errore registrazione dati [' + returnItem + ']');

                logSuccess($translate.instant('DatoSalvato'));
                getListAttach(vm.record.Id);
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function deleteAttach(item) {
            var msg = ' ' + $translate.instant('Allegato') +' ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError($translate.instant('AttenzioneAllegato'));

                    var index = vm.list.attach.indexOf(item)
                    vm.list.attach.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }


        //PDP
        function attivaPdp(username) {
            datacontext.studente_attivaPdp(username).then(function (data) {
                if (!data || !data.Id || data.Id == 0) {
                    logError($translate.instant('OperazioneNonRiuscita'));
                    return;
                }
                vm.record.Pdp = data.Pdp;     //per aggiornare il record
                vm.records[vm.index] = vm.record; //per aggiornare la lista senza ricaricare la pag

                logSuccess($translate.instant('PDPAttivo'));                
            });
        }

        function annullaPdp(username) {
            var msg = $translate.instant('AvvisoAnnullarePDP');
            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                datacontext.studente_annullaPdp(username).then(function (data) {
                    if (!data || !data.Id || data.Id == 0) {
                        logError($translate.instant('OperazioneNonRiuscita'));
                        return;
                    }

                    vm.record.Pdp = data.Pdp;     //per aggiornare il record
                    vm.records[vm.index] = vm.record; //per aggiornare la lista senza ricaricare la pag
                   
                    logSuccess($translate.instant('PDPDisattivato'));
                });
            });
        }

        function getPdp(studenteId) {
            vm.piano = '';
            datacontext.pdp_getAll(studenteId).then(function (data) {                
                
                if (!data || !data.Id || data.Id == 0) {
                    var object = {
                        DocenteId: 0,
                        StudenteId: studenteId,
                        Nome: vm.record.Nome,
                        Cognome: vm.record.Cognome,
                        Campo1: 100,
                        Campo2: 0,
                        Campo3: 0
                    }

                    datacontext.pdp_add(object).then(function (data2) {                        
                        vm.slider.value = data2.Campo1;
                        $timeout(function () {
                            $scope.$broadcast('rzSliderForceRender');
                        });
                        return vm.piano = data2;
                    });
                }
                else {
                    if (!data.Campo1 || data.Campo1 == 0)
                        data.Campo1 = 100;

                    vm.slider.value = data.Campo1;
                    $timeout(function () {
                        $scope.$broadcast('rzSliderForceRender');
                    });
                    return vm.piano = data;
                }

                
            });
        }

        function updatePdp(isValid, item) {
            if (isValid) {                
                item.Campo1 = vm.slider.value;
                return datacontext.pdp_update(item).then(function (data) {
                        vm.piano = data;
                        //vm.records[vm.index] = vm.record;
                        logSuccess($translate.instant('DatoSalvato'));
                });
            }
        }

        function goSession(sessionId) {
            $location.path('/EDUP_session/' + sessionId);
        }

        function getPerformanceStudenteMaterie() {
            vm.performanceMaterie = [];
            return datacontext.performanceMateria_getAll(vm.fAnnoSessioni, 0, vm.record.Id).then(function (data) {                
                vm.performanceMaterie = data;
            });
        }

        function updateAccount() {
            return datacontext.studente_update(vm.record).then(function (data) {
                if (!data) {
                    cerca();
                    logSuccess($translate.instant('DatoSalvato'));
                }

                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function invioCredenziali() {
            var msg = $translate.instant('RipristinoPassword') + ' ' + vm.record.Username + ' ' + $translate.instant('Credenziali');
            bDialog.confirmationDialog($translate.instant('InvioCredenziali'), msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(vm.record.Email).then(function (data) {
                    if (data != "204") return logError($translate.instant('ImpossibileEseguireOperazione'));
                    logSuccess($translate.instant('OperazioneEffettuata'));
                });
            });
        }

        function modificaPassword() {
            datacontext.user_setPassword(vm.record.Username, vm.newPassword).then(function (data) {
                if (data == '200') {
                    vm.newPassword = '';
                    logSuccess($translate.instant('OperazioneEffettuata'));
                }
                else 
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }
    }
})();
